module.exports = __webpack_public_path__ + "img/20210430_111234.3bb4319c.jpg";